import { useEffect } from "react";

/**
 * Lightweight SEO hook to update document title, meta description, keywords
 * and canonical link without needing react-helmet.
 */
const DEFAULT_TITLE =
  "Catherine' Shiatsu — Praticienne en Shiatsu à La Ciotat";
const DEFAULT_DESC =
  "Séances de Shiatsu thérapeutique à La Ciotat. Détente, bien-être et rééquilibrage énergétique. Particuliers et entreprises (QVCT).";

const setMeta = (name, content, attr = "name") => {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  if (!href) return;
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const useSEO = ({
  title,
  description,
  keywords,
  image,
  type = "website",
  jsonLd,
} = {}) => {
  useEffect(() => {
    const finalTitle = title || DEFAULT_TITLE;
    const finalDesc = description || DEFAULT_DESC;
    document.title = finalTitle;
    setMeta("description", finalDesc);
    if (keywords) setMeta("keywords", keywords);

    // Open Graph
    setMeta("og:title", finalTitle, "property");
    setMeta("og:description", finalDesc, "property");
    setMeta("og:type", type, "property");
    setMeta("og:url", window.location.href, "property");
    if (image) setMeta("og:image", image, "property");

    // Twitter
    setMeta("twitter:card", image ? "summary_large_image" : "summary");
    setMeta("twitter:title", finalTitle);
    setMeta("twitter:description", finalDesc);
    if (image) setMeta("twitter:image", image);

    setCanonical(window.location.href);

    // JSON-LD structured data
    let ld = document.getElementById("page-jsonld");
    if (jsonLd) {
      if (!ld) {
        ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = "page-jsonld";
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) {
      ld.remove();
    }
  }, [title, description, keywords, image, type, jsonLd]);
};

export default useSEO;
